import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { ItemTransferDuration } from 'entities/ticket/ui/direction-detail'
import { AirportChange } from 'entities/ticket/ui/direction-detail/ui/airport-change'
import { BaggageRecheck } from 'entities/ticket/ui/direction-detail/ui/baggage-recheck'

import NightTransferImg from 'shared/icons/night_transfer.svg'
import { prepareTimeShow } from 'shared/lib/ticketRender.ts'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import { TransferModal } from '../transfer-modal'

import { nightTransferList } from './constants/lists'
import s from './styles.module.scss'

interface Props {
  data?: ItemTransferDuration
}

export const TransferNight = ({ data }: Props) => {
  const { openDialog } = useDialogBottomSheet()
  const { t } = useTranslation()

  const showInfos = data?.is_airport_change || data?.baggage_recheck

  const onOpenModal = () => {
    openDialog({
      child: (
        <TransferModal
          title={t('transfer_details.night_transfer.title')}
          description={t('transfer_details.night_transfer.description')}
          image={NightTransferImg}
          subtitle={t('transfer_details.night_transfer.subtitle')}
          list={nightTransferList}
        />
      ),
    })
  }
  return (
    <div className={s.transferNight}>
      <AppIcon
        id={AllIcons.MOON_NEW}
        className={s.icon}
        width={24}
        height={24}
      />

      <div className={s.box}>
        <div className={s.wrapper}>
          <p className={clsx(s.title, 'semi-bold-16')}>
            {t('transfer_details.night_transfer_in_city', { city: data?.name })}
          </p>

          <div className={s.wrapperTransfer}>
            {showInfos && (
              <div className={s.infos}>
                {data?.is_airport_change && <AirportChange />}
                {data?.baggage_recheck && <BaggageRecheck />}
              </div>
            )}

            <p className={clsx('medium-14', s.transferTime)}>
              {t('wait_time_transfer', {
                duration: prepareTimeShow(data?.time),
              })}
            </p>
          </div>
        </div>

        <div
          className={s.infoCity}
          onClick={onOpenModal}
        >
          <AppIcon
            width={24}
            height={24}
            id={AllIcons.INFO}
            className={s.infoIcon}
          />
        </div>
      </div>
    </div>
  )
}
